module.exports = __webpack_public_path__ + "media/wibo_1.43950c2d.mp4";